import styled from "styled-components";

export const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 50px 0 50px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

export const TableContent = styled.div`
    table {
        thead tr th {
            width: initial;
            vertical-align: middle;
            font-weight: 700;
            font-size: 0.95rem;
            background: #efefef;
        }

        tbody tr td {
            vertical-align: middle;
            white-space: nowrap;
            font-size: 0.95rem;

            &.modified {
                color: #ff963e;

                &.allowedPaymentMethod {
                    & > * {
                        color: #ff963e;
                        border-color: #ff963e;
                    }
                }
            }
        }
    }

    .MuiDialogContent-dividers {
        padding: 16px;
    }

    .MuiTableContainer-root {
        ::-webkit-scrollbar {
            width: 9px;
            height: 9px;
            border-radius: 3px;
        }

        ::-webkit-scrollbar-thumb {
            background: #dee2e6;
            border-radius: 3px;

            &:hover {
                background: #9c9a9a;
            }
        }
    }
`;